import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { DialogResultService } from "./../services/dialog-result.service";
// import { ItemDataService } from './../services/item-data.service';
// import { Subscription } from 'rxjs';

@Component({
    selector: "app-dialog",
    templateUrl: "./dialog.component.html",
    styleUrls: ["./dialog.component.scss"],
    standalone: false
})
export class DialogComponent implements OnInit {
  @Input() public closable = true;
  @Input() public visible: boolean;
  @Input() public itemName: string;
  @Input() public sectionName: string;
  @Output() public visibleChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() public dialogAnswer: EventEmitter<string> =
    new EventEmitter<string>();
  //subsciption: Subscription;
  public myItem;

  constructor(private dialogResultService: DialogResultService) { }

  ngOnInit() {
  }

  choice(myChoice) {
    //this.dialogResultService.changeMessage(myChoice);
    this.dialogAnswer.emit(myChoice);
    this.close();
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
